<div [formGroup]="triggerQueryPubSubForm">
  <!--TOPIC-->
  <div class="form-group">
    <label for="topic" translate>Topic</label>
    <scitis-required-field-indicator></scitis-required-field-indicator>
    @if (isLoadingTopics) {
      <span class="fa-solid fa-spinner fa-spin"></span>
    }
    <ng-select (focusout)="onFocusOut()"
      [items]="topics" [ngClass]="{ 'is-invalid': f.topic.errors }"
      bindLabel="name" bindValue="id" formControlName="topic" id="topic"
      placeholder="Select subscriber">
    </ng-select>
    <input [hidden]="true" [ngClass]="{ 'is-invalid': f.topic.errors }"
      class="form-control"
      id="selectedNewSubscriber" type="text">
      @if (f.topic.errors) {
        <div class="invalid-feedback">
          <span translate>Topic required</span>
        </div>
      }
    </div>

    <!--BODY TYPE-->
    <div class="form-group">
      <label for="messageContentType" translate>Type</label>
      <scitis-required-field-indicator></scitis-required-field-indicator>
      <ng-select [items]="messageContentTypeItems" [ngClass]="{ 'is-invalid': f.messageContentType.errors }"
        (change)="onChangeType($event)"
        formControlName="messageContentType" id="messageContentType">
      </ng-select>
      @if (f.messageContentType.errors?.required) {
        <div class="invalid-feedback">
          <span translate>Type required</span>
        </div>
      }
    </div>

    <!--BODY-->
    <div class="form-group">
      @switch (triggerQueryAction.messageContentType) {
        @case (messageContentType.TEXT) {
          <div>
            <label for="text" translate>PubSub Text</label>
            <textarea (focusout)="onFocusOut()"
              class="form-control"
              formControlName="text"
              id="text"
              name="text"
              rows="10">
            </textarea>
          </div>
        }
        @case (messageContentType.JSON) {
          <div>
            <label for="JSON" translate>PubSub JSON</label>
            <textarea (focusout)="onFocusOut()"
              [ngClass]="{ 'is-invalid': f.JSON.errors }"
              class="form-control"
              formControlName="JSON"
              id="JSON"
              name="JSON"
              rows="10">
            </textarea>
            @if (f.JSON.errors) {
              <div class="invalid-feedback">
                @if (f.JSON.errors?.parseError) {
                  <span [innerText]="f.JSON.errors?.parseError | translate"></span>
                }
              </div>
            }
          </div>
        }
        @case (messageContentType.ARGOS_EVENT) {
          <div class="grid-layout"
            >
            <ng-container formArrayName="argosEvent">
              @for (fieldForm of argosEventFields; track fieldForm; let i = $index) {
                <div [formGroup]="fieldForm"
                  [ngClass]="fieldForm.value['fieldName']">
                  <div>
                    @switch (fieldForm.controls.dataType.value) {
                      <!--number data type-->
                      @case ('number') {
                        <div class="form-group">
                          <label for="numberValue" [innerText]="fieldForm.value['fieldName']"></label>
                          <input id="numberValue"
                            [ngClass]="{ 'is-invalid': fieldForm.controls.value.errors }"
                            formControlName="value"
                            (focusout)="onFocusOut()"
                            type="number"
                            name="value"
                            class="form-control truncate">
                          </div>
                        }
                        <!--boolean data type-->
                        @case ('boolean') {
                          <div class="form-group col-auto">
                            <div class="custom-control custom-switch">
                              <input class="custom-control-input"
                                (change)="onFocusOut()"
                                id="booleanValue"
                                formControlName="value"
                                type="checkbox">
                                <label class="custom-control-label" for="booleanValue" [innerText]="fieldForm.value['fieldName']"></label>
                              </div>
                            </div>
                          }
                          <!--event severity data type-->
                          @case ('eventSeverity') {
                            <div class="form-group">
                              <label for="severityValue" [innerText]="fieldForm.value['fieldName']"></label>
                              <ng-select [ngClass]="{ 'is-invalid': fieldForm.controls.value.errors }"
                                (change)="onFocusOut()"
                                [items]="signalLabels"
                                id="severityValue"
                                formControlName="value">
                              </ng-select>
                            </div>
                          }
                          <!--string data type-->
                          @case ('string') {
                            <div class="form-group">
                              <label for="stringValue" [innerText]="fieldForm.value['fieldName']"></label>
                              <textarea id="stringValue"
                                [ngClass]="{ 'is-invalid': fieldForm.controls.value.errors }"
                                formControlName="value"
                                (focusout)="onFocusOut()"
                                rows="2"
                                maxlength="10000"
                                type="text"
                                name="value"
                              class="form-control truncate"></textarea>
                            </div>
                          }
                        }
                      </div>
                    </div>
                  }
                </ng-container>
              </div>
            }
          }
        </div>
      </div>
